import { useMutation } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'

import { graphql } from '~/gql'
import { useGraphQLRequest } from '~/hooks/useGraphQLRequest'
import { exists } from '~/utils'

import { useStrategyMemoId } from './useStrategyMemoId'

const document = graphql(`
  mutation StrategyMemoEditPage_ArchiveStrategyMemo($strategyMemoId: ID!) {
    updateCustomerStrategyMemo(id: $strategyMemoId, status: archived) {
      id
    }
  }
`)

export const useArchiveStrategyMemoMutation = (
  options: MutationOptions<void, void> = {},
) => {
  const { t } = useTranslation()
  const graphQLRequest = useGraphQLRequest()
  const strategyMemoId = useStrategyMemoId()

  return useMutation({
    mutationFn: async () => {
      const result = await graphQLRequest({
        document,
        variables: { strategyMemoId },
      })

      const ok = exists(result.updateCustomerStrategyMemo?.id)
      if (!ok) {
        throw new Error(t('archive_failed_2'))
      }
    },
    ...options,
  })
}
